import type { ReactNode } from 'react';
import armorImg from '../assets/gallery/armor.jpg';
import bananaImg from '../assets/gallery/banana.jpg';
import forestImg from '../assets/gallery/forest.jpg';
import waveImg from '../assets/gallery/wave.jpg';
import styles from './GalleryPage.module.scss';
import { Header } from './Header';

const GALLERY_IMAGES = [forestImg, bananaImg, waveImg, armorImg];

export function GalleryPage({
  eyebrow,
  title,
  subtitle,
  tone = 'default',
  children,
}: {
  eyebrow?: string;
  title: string;
  subtitle: string;
  tone?: 'default' | 'error';
  children?: ReactNode;
}) {
  return (
    <div className={styles.page}>
      <Header />
      <main className={styles.gallery}>
        {GALLERY_IMAGES.map((src) => (
          <div key={src} className={styles.gallery__item}>
            <img src={src} alt="" />
          </div>
        ))}
      </main>
      <div className={styles.card}>
        <div className={styles.intro}>
          <div className={styles.heading}>
            {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
            <h1
              className={
                tone === 'error'
                  ? `${styles.title} ${styles.titleError}`
                  : styles.title
              }
            >
              {title}
            </h1>
          </div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
        {children && <div className={styles.actions}>{children}</div>}
      </div>
    </div>
  );
}

export function CtaLink({
  href,
  variant = 'primary',
  children,
}: {
  href: string;
  variant?: 'primary' | 'outline';
  children: ReactNode;
}) {
  return (
    <a
      href={href}
      className={
        variant === 'outline'
          ? `${styles.cta} ${styles.ctaOutline}`
          : styles.cta
      }
    >
      {children}
    </a>
  );
}
